// Static data for the four RSA brands.
export const ASSETS = {
  rsaLogo:
    "https://customer-assets.emergentagent.com/job_rsa-redesign/artifacts/5mk59i4j_RSA%20Logo.PNG",
};

export const BRANDS = [
  {
    slug: "equione",
    name: "EquiOne",
    tagline: "Nourishing Horses. Empowering Riders.",
    heroLine:
      "Premium horse feeds, hay, grains & supplements — 100% natural, preservative-free and steroid-free, formulated by equine nutritionists across India.",
    species: "Horses & Equine",
    website: "https://www.equione.in",
    logo: "https://customer-assets.emergentagent.com/job_rsa-redesign/artifacts/vqst2c5m_image.png",
    image: "https://equione.in/brand/hero_field.png",
    short:
      "Premix feeds, pure grains, imported hay, mineral blocks and supplements — formulated by equine nutritionists and veterinarians for every life stage.",
    description:
      "EquiOne was founded with a singular vision — to deliver the finest quality nutrition to horses across India and beyond. Our team of equine nutritionists and veterinarians formulate feeds that meet the diverse needs of every horse — from sport to leisure to breeding stock. Every product undergoes rigorous quality control, ensuring your horse receives nothing but the best.",
    manifesto:
      "Trusted Equine Nutrition. 100% Natural. Preservative Free. Steroid Free. Vet Formulated. Made in India.",
    pillars: [
      {
        label: "Premix Feeds",
        items: "Basic · Elite · Sports · Foal · Mare · Stallion Mix",
        note: "9 complete formulas — one for every life stage and workload.",
      },
      {
        label: "Pure Grains",
        items: "Crushed Barley · Crushed Oats · Flax · Whole Oats",
        note: "Whole-grain energy, milled fresh and moisture-locked.",
      },
      {
        label: "Hay & Pellets",
        items: "Timothy · Alfalfa · Mountain · Beet · Chaff",
        note: "8 imported forages — long-fibre, low-NSC, harvest-dated.",
      },
      {
        label: "Supplements",
        items: "Mobility · AltVital · Oralyte · Hoof Nourish",
        note: "14 targeted vitamins, minerals and performance blends.",
      },
    ],
    benefits: [
      "100% Natural, whole-grain nutrition",
      "Preservative & steroid free",
      "Vet-formulated by equine nutritionists",
      "Rigorous batch-level quality control",
    ],
    products: [
      "Elite Mix — Performance & Training",
      "Sports Mix — High Endurance",
      "Mountain Hay — High-Altitude Grass",
      "Alfalfa Chaff — Green Energy",
      "AltVital — Micronutrient Support",
      "Mobility — Joint & Cartilage Support",
      "Crushed Barley — Strength & Stamina",
      "Himalayan Rock Salt Blocks",
    ],
    process: [
      { t: "Selected", d: "Certified growers screened for cut, cure and moisture." },
      { t: "Imported", d: "Sealed containers, temperature-logged, port-cleared." },
      { t: "Blended", d: "Concentrates milled in-house at our Kamshet floor." },
      { t: "Vet-Approved", d: "Every formula signed off by equine nutritionists." },
      { t: "Delivered", d: "To stable, yard or paddock — nationwide." },
    ],
    voice: {
      quote:
        "We switched three yards to EquiOne last season. The horses hold weight through the work — and our vet bills speak for themselves.",
      by: "Sanjay P.",
      role: "Yard manager · Pune",
    },
    accent: "from-magenta to-aubergine-light",
  },
  {
    slug: "hopsy",
    name: "Hopsy",
    tagline: "Slow-cured hay. Deeply cared-for little ones.",
    heroLine:
      "Premium 100% sun-cured hay, pellets and bedding for rabbits, guinea pigs, hamsters and chinchillas.",
    species: "Rabbits, Guinea Pigs, Hamsters & Chinchillas",
    website: "https://www.hayhopsy.com",
    logo: "https://customer-assets.emergentagent.com/job_rsa-redesign/artifacts/barcfxnk_hopsy_transparent_compressed.png",
    image:
      "https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    short:
      "Hopsy crafts premium, 100% sun-cured hay, pellets and bedding for rabbits, guinea pigs, hamsters and chinchillas — the way nature intended.",
    description:
      "At the heart of Hopsy is a simple belief: small pets deserve the same quality of food and care as any member of the family. Nine SKUs. Four species. One insistence — that every strand of hay be slow-cured, hand-sorted and dust-screened before it reaches your burrow.",
    manifesto:
      '"We feed pets the way we\'d feed family." Every batch is grown slowly, cured naturally, screened by hand, and packed fresh — because a rabbit\'s gut has no room for shortcuts.',
    pillars: [
      {
        label: "Hay",
        items: "Timothy · Alfalfa · Meadow · Orchard",
        note: "Long-strand, dust-screened, harvest-dated.",
      },
      {
        label: "Pellets",
        items: "Complete · Timothy · Alfalfa",
        note: "Fibre-first, fortified with vet-informed micros.",
      },
      {
        label: "Specialty",
        items: "Bunny Bhel & seasonal blends",
        note: "High-fibre treats — never sugar-first.",
      },
      {
        label: "Bedding",
        items: "Natural · Absorbent",
        note: "Soft on feet, kind on hutch.",
      },
    ],
    benefits: [
      "100% sun-cured, slow-grown hay",
      "Low-dust — screened and hand-selected",
      "Dental-kind long strands",
      "Vet-informed formulations",
    ],
    products: [
      "Timothy Hay — from ₹350",
      "Alfalfa Hay — from ₹200",
      "Timothy Pellets — from ₹350",
      "Bunny Bhel Specialty — from ₹350",
    ],
    diet: [
      { pct: "70%", label: "Timothy Hay", note: "Always available" },
      { pct: "20%", label: "Fortified Food", note: "Daily portion" },
      { pct: "8%", label: "Greens", note: "Fresh, rotated" },
      { pct: "2%", label: "Treats", note: "Occasional, considered" },
    ],
    process: [
      { t: "Harvested", d: "Sun-drenched fields cut at peak ripeness." },
      { t: "Hand-Selected", d: "Only the long, green strands make the cut." },
      { t: "To the Mill", d: "Gently trucked from meadow to sorting floor." },
      { t: "Baled", d: "Pressed into round and square bales with care." },
      { t: "Hand-Sorted", d: "Dust screened, debris removed, strand by strand." },
      { t: "Filtered", d: "Baled hay sifted to remove dust and fine debris." },
      { t: "Bagged", d: "Clean, long-strand hay packed into Hopsy bags." },
      { t: "Packed & Shipped", d: "Sealed fresh in Hopsy pouches — on to happy homes." },
    ],
    voice: {
      quote:
        "My two rabbits have never had healthier coats or calmer tummies. The Timothy hay is pristine — long strands, zero dust.",
      by: "Aanya R.",
      role: "Rabbit parent · Mumbai",
    },
    accent: "from-green-700 to-aubergine",
  },
  {
    slug: "avipure",
    name: "AviPure",
    tagline: "Premium Bird Nutrition",
    heroLine:
      "Human-grade sunflower blends, sprouting kits and fortified pellets for parrots, finches and aviary birds.",
    species: "Parrots, Finches & Aviary Birds",
    website: null,
    logo: "https://customer-assets.emergentagent.com/job_rsa-redesign/artifacts/y5jjd0vw_image.png",
    image:
      "https://images.unsplash.com/photo-1552728089-57bdde30beb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    short:
      "Vibrant birds are made in the kitchen, not the cage. AviPure delivers human-grade seed blends and fortified feed — engineered for plumage, bone strength and lifelong vitality.",
    description:
      "AviPure sources sunflower, safflower and specialty seeds from certified growers, then screens every batch for moisture, mould and aflatoxins. From single-species blends to sprouting kits, we deliver the kind of freshness that shows up in feather, song and mood.",
    manifesto:
      "Aviary keepers know the difference a clean seed makes. AviPure keeps that difference on your shelf — bright, screened, tested, delivered.",
    pillars: [
      {
        label: "Seed Blends",
        items: "Sunflower · Safflower · Millet",
        note: "Human-grade sourcing, batch-screened.",
      },
      {
        label: "Pellets",
        items: "Parrot · Finch · Canary",
        note: "Fortified with Ca, D3 and essential aminos.",
      },
      {
        label: "Sprouting",
        items: "Kits · Grains · Sprouted seed",
        note: "Living feed for peak vitality.",
      },
      {
        label: "Add-ons",
        items: "Cuttle · Mineral · Grit",
        note: "The finishing touches your aviary asks for.",
      },
    ],
    benefits: [
      "Human-grade sunflower & seed sourcing",
      "Mould & aflatoxin screened",
      "Calcium & D3 fortified options",
      "Sprouting kits for fresh feed",
    ],
    products: [
      "Sunflower Seed Blend",
      "Parrot & Finch Mix",
      "Fortified Avian Pellets",
      "Sprouting Kit",
    ],
    process: [
      { t: "Sourced", d: "Certified growers, single-origin traceability." },
      { t: "Screened", d: "Moisture, mould and aflatoxin tests on every batch." },
      { t: "Blended", d: "Species-specific ratios formulated by nutritionists." },
      { t: "Sealed", d: "Nitrogen-flushed for freshness and shelf-life." },
      { t: "Delivered", d: "Direct to homes, aviaries and pet stores." },
    ],
    voice: {
      quote:
        "My African Greys have never been noisier — in a good way. The plumage colour is back and the sprouting kit is a weekend ritual now.",
      by: "Kunal D.",
      role: "Aviary keeper · Bengaluru",
    },
    accent: "from-purple-600 to-aubergine",
  },
  {
    slug: "nutrimax",
    name: "NutriMax",
    tagline: "Wholesome Pantry, Globally Sourced",
    heroLine:
      "Slow-milled raw oats and hand-graded exotic dry fruits — for pantries that take breakfast seriously.",
    species: "Premium Human Foods · Oats & Exotic Dry Fruits",
    website: null,
    logo: null,
    image:
      "https://images.unsplash.com/photo-1559656914-a30970c1affd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    short:
      "Slow-milled raw oats and hand-graded exotic dry fruits — sourced from the world's finest farms and packed for everyday wellness.",
    description:
      "NutriMax is RSA's human-grade pantry brand. From slow-milled raw oats to California almonds, Iranian pistachios, Turkish apricots and Chilean walnuts — every kilo is hand-graded, moisture-controlled and packed in food-safe facilities to bring world-class nutrition to your kitchen.",
    manifesto:
      "The best breakfast is the one you didn't have to think about. NutriMax makes wholesome unglamorous — and that's the point.",
    pillars: [
      {
        label: "Oats",
        items: "Rolled · Steel-Cut · Whole",
        note: "Slow-milled, moisture-locked.",
      },
      {
        label: "Nuts",
        items: "Almonds · Cashews · Walnuts",
        note: "California, Kashmir & Chile origins.",
      },
      {
        label: "Dry Fruits",
        items: "Pistachios · Apricots · Figs · Dates",
        note: "Hand-graded, no added sugar.",
      },
      {
        label: "Blends",
        items: "Trail · Muesli · Custom",
        note: "Tailored to your household or brand.",
      },
    ],
    benefits: [
      "Slow-milled raw & steel-cut oats",
      "Globally sourced exotic dry fruits & nuts",
      "No added sugar, salt or preservatives",
      "Food-grade hygienic packing & traceability",
    ],
    products: [
      "Raw & Steel-Cut Oats",
      "Premium Almonds, Cashews & Walnuts",
      "Pistachios, Apricots & Figs",
      "Trail Mixes & Custom Blends",
    ],
    process: [
      { t: "Sourced", d: "From certified single-origin farms worldwide." },
      { t: "Graded", d: "Hand-sorted for size, colour and moisture." },
      { t: "Cleaned", d: "Cold-cleaned — no chemical wash, no oils." },
      { t: "Packed", d: "Food-safe pouches, dated for freshness." },
      { t: "Delivered", d: "To pantries, gift boxes and premium retailers." },
    ],
    voice: {
      quote:
        "Their steel-cut oats and California almonds are a fixture in our breakfast now. Clean, honest, no funny aftertaste.",
      by: "Meera J.",
      role: "Home baker · Delhi",
    },
    accent: "from-magenta to-purple-700",
  },
];

export const COMMODITIES = [
  {
    tag: "01",
    name: "Raw Oats",
    kind: "Grain",
    body:
      "Slow-milled from clean, hand-graded oat kernels. Rolled, steel-cut and whole — a versatile core across our animal feed and human pantry lines.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_rsa-redesign/artifacts/1tr8v9x7_image.png",
  },
  {
    tag: "02",
    name: "Sunflower Seeds",
    kind: "Seed",
    body:
      "Plump, oil-rich sunflower kernels — the heart of AviPure and a nutrient-dense inclusion across specialty formulations for high-energy birds.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_rsa-redesign/artifacts/wxaah9kj_image.png",
  },
  {
    tag: "03",
    name: "Timothy Hay",
    kind: "Hay",
    body:
      "Long-fibre, low-NSC grass hay. The gold standard for adult horses, rabbits and guinea pigs — cut, cured and baled to hold its aroma.",
    image:
      "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    tag: "04",
    name: "Alfalfa Hay",
    kind: "Hay",
    body:
      "Protein-rich legume hay. Perfect for growing animals, nursing dams and hard-working horses that need calorie-dense forage.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_rsa-redesign/artifacts/kp1neje9_image.png",
  },
  {
    tag: "05",
    name: "Meadow Hay",
    kind: "Hay",
    body:
      "A soft, aromatic mix of native grasses — gentler than Timothy and beloved by small pets for its variety and palatability.",
    image:
      "https://images.unsplash.com/photo-1500534623283-312aade485b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    tag: "06",
    name: "Orchard Hay",
    kind: "Hay",
    body:
      "Smooth, sweet-smelling grass hay grown under fruit trees. A soft-textured alternative that horses and rabbits find hard to resist.",
    image:
      "https://images.unsplash.com/photo-1445264718234-a623be589d37?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const COMPANY = {
  name: "RSA Overseas Pvt. Ltd.",
  shortName: "RSA Overseas",
  tagline: "Importer of Seeds & Hay. Manufacturer of Animal Feeds.",
  est: "2018",
  phone: "+91 78220 86946",
  phoneRaw: "+917822086946",
  email: "info@rsaoverseas.com",
  address:
    "Warehouse No 1 & 2, Near Kamshet Railway Station, Kamshet, Pune - 410405",
  gst: "27AAJCR1114N1Z8",
  trustedBy: "5,000+",
};

export const SLIDERS = {
  import: {
    eyebrow: "Global Import",
    heading: "From the world's finest fields — to Kamshet.",
    body:
      "Every consignment is inspected at origin, sealed in food-grade containers and re-graded at our Pune warehouse.",
    slides: [
      {
        title: "Container Freight",
        caption: "Sealed, moisture-controlled containers from origin ports.",
        image:
          "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "Port Handling",
        caption: "Direct arrivals at JNPT & Mundra — CHA-cleared, temperature logged.",
        image:
          "https://images.unsplash.com/photo-1578575437130-527eed3abbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "Bulk Hay Bales",
        caption: "Baled at source, weighed, and cross-verified on arrival.",
        image:
          "https://images.unsplash.com/photo-1500595046743-cd271d694d30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "Seed Sourcing",
        caption: "Sunflower, oat and specialty seeds from certified growers.",
        image:
          "https://images.unsplash.com/photo-1597848212624-a19eb35e2651?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "Warehouse Intake",
        caption: "Every bale hand-checked before it enters our Kamshet floor.",
        image:
          "https://images.unsplash.com/photo-1773414582372-43ed2b1db2e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
    ],
  },
  equine: {
    eyebrow: "Equine Feeds · EquiOne",
    heading: "Feed built around forage. Formulated by nutritionists.",
    body:
      "Timothy, Alfalfa, Mountain hay and Alfalfa Chaff — plus premix feeds, grains and vet-formulated supplements manufactured for every life stage.",
    slides: [
      {
        title: "Nourishing Horses",
        caption:
          "Full-spectrum equine nutrition — trusted across Indian yards, riding schools and stud farms.",
        image: "https://equione.in/brand/hero_real_1.png",
      },
      {
        title: "Field & Forage",
        caption:
          "Timothy · Alfalfa · Mountain · Beet · Chaff — long-fibre, low-NSC and harvest-dated.",
        image: "https://equione.in/brand/hero_field.png",
      },
      {
        title: "Premix Feeds",
        caption:
          "Nine complete formulas — Elite, Sports, Foal, Mare, Stallion and more.",
        image: "https://equione.in/brand/feeds.jpg",
      },
      {
        title: "Pure Grains",
        caption:
          "Crushed Barley, Crushed Oats, Whole Grains and Flax — milled fresh, moisture-locked.",
        image: "https://equione.in/brand/grains.jpg",
      },
      {
        title: "Hay & Pellets",
        caption:
          "Eight imported forages ready for the yard — long-fibre, dust-screened, harvest-dated.",
        image: "https://equione.in/brand/hay.jpg",
      },
      {
        title: "Vet-Formulated Supplements",
        caption:
          "Fourteen targeted vitamins, minerals and performance blends — Mobility, AltVital, Oralyte.",
        image: "https://equione.in/brand/supplements.jpg",
      },
    ],
  },
  small: {
    eyebrow: "Small Pets, Birds & Pantry",
    heading: "One warehouse. Every keeper.",
    body:
      "Hopsy hay for rabbits & small pets, AviPure sunflower blends for birds, and NutriMax oats & dry fruits for the family pantry.",
    slides: [
      {
        title: "Hopsy · Small Pets",
        caption:
          "Dust-free second-cut hay for rabbits, guinea pigs & chinchillas.",
        image:
          "https://images.unsplash.com/photo-1511542229800-663a99ca1817?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "AviPure · Aviary",
        caption:
          "Sunflower and human-grade seed mixes for parrots & finches.",
        image:
          "https://images.unsplash.com/photo-1764294478783-1f9b852813df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "NutriMax · Pantry",
        caption: "Slow-milled raw oats and hand-graded exotic dry fruits.",
        image:
          "https://images.unsplash.com/photo-1614961233913-a5113a4a34ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "Guinea Pig Ready",
        caption: "Harvest-dated hay, portioned fresh — never bulk-repacked.",
        image:
          "https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
      {
        title: "Everyday Wellness",
        caption: "Nuts, seeds and grains packed in food-safe facilities.",
        image:
          "https://images.unsplash.com/photo-1559656914-a30970c1affd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      },
    ],
  },
};
